import { render } from "./apply-modal.vue?vue&type=template&id=72d968da&scoped=true"
import script from "./apply-modal.vue?vue&type=script&lang=js"
export * from "./apply-modal.vue?vue&type=script&lang=js"

import "./apply-modal.vue?vue&type=style&index=0&id=72d968da&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d968da"]])

export default __exports__